import common from "./api_modules/common";
import account from "./api_modules/account";
import info from "./api_modules/info";
import job from "./api_modules/job";
import school from "./api_modules/school";
import pay from "./api_modules/pay";
import studentManage from './api_modules/studentManage'

export default {
  common, account, info, job, school, pay, studentManage,
};